import noScroll from "@/utils/noScroll.js";

export default function popup(element, data) {
    const popupId = data.popupId;
    if (!popupId) {
        return;
    }

    const target = document.getElementById(popupId);
    if (!target) {
        return;
    }

    const className = data.class || "open";
    const closeSelector = data.closeSelector || "[data-popup-close]";

    let isOpen = false;

    function onKeyDown(event) {
        if (event.key === "Escape") {
            close();
        }
    }

    function open() {
        if (isOpen) {
            return;
        }
        isOpen = true;
        target.classList.add(className);
        noScroll.hideScroll();
        // Слушатель живёт только пока окно открыто, чтобы несколько попапов
        // на странице не ловили Escape одновременно
        document.addEventListener("keydown", onKeyDown);
    }

    function close() {
        if (!isOpen) {
            return;
        }
        isOpen = false;
        target.classList.remove(className);
        noScroll.showScroll();
        document.removeEventListener("keydown", onKeyDown);
    }

    element.addEventListener("click", open);

    target.addEventListener("click", function (event) {
        if (event.target === target) {
            close();
            return;
        }
        if (event.target.closest(closeSelector)) {
            close();
        }
    });
}
